export default "__VITE_ASSET__B3kQcKe7__"